module.exports = __webpack_public_path__ + "static/pack-e9f3c4116ea5ab5007b7a73d295bfedc.png";